import {
  BaSeIcon,
  BaSeParagraph,
  BaSeSmall1,
  BaSeStepper,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import { useStep } from './hook/useStep';
import {
  Container,
  ImageResult,
  ImageWrapper,
  ResultBoxMessageWrapper,
  ResultTextMessagetWrapper,
  ResultTextSubTitle,
  ResultTextTitle,
  ResultWrapper,
  StepWrapper,
  TextLink,
} from './result-styled';

import {
  ilustration_error,
  ilustration_error_resp,
  ilustration_success,
  ilustration_success_resp,
} from '../../../../utils/images';

// eslint-disable-next-line sonarjs/cognitive-complexity
export const ResultFail = () => {
  const { save } = useStep();

  const steps = React.useMemo(
    () => [
      {
        isCompleted: true,
        withError: false,
        isClickable: false,
        title: 'Proximidade',
      },
      {
        isCompleted: true,
        withError: false,
        isClickable: false,
        title: 'Avaliação',
      },
      {
        isCompleted: true,
        withError: true,
        isClickable: false,
        title: 'Adjetivos',
      },
    ],
    [],
  );
  return (
    <React.Fragment>
      <Container>
        <ResultWrapper>
          <StepWrapper>
            <BaSeStepper
              steps={steps}
              onStepChange={() => {}}
              currentStep={3}
              activeWithErrorColor={BaSeTheme.colors.feedbackInterface.erro45}
              activeColor={BaSeTheme.colors.feedbackInterface.sucesso}
              completedColor={BaSeTheme.colors.feedbackInterface.sucesso70}
              orientation={'horizontal'}
            />
          </StepWrapper>
          <ResultBoxMessageWrapper isSuccess={false}>
            <BaSeIcon
              color={BaSeTheme.colors.defaultColors.white}
              description={'Error'}
              name={getIcon(false)}
              size={32}
            />
            <ResultTextMessagetWrapper>
              <ResultTextTitle>
                <BaSeParagraph
                  isBold
                  color={BaSeTheme.colors.defaultColors.white}
                >
                  Questionário não enviado!
                </BaSeParagraph>
              </ResultTextTitle>
              <ResultTextSubTitle>
                <BaSeParagraph color={BaSeTheme.colors.defaultColors.white}>
                  Às vezes isso acontece, tente novamente em alguns instantes
                  acionando a opção abaixo.
                </BaSeParagraph>

                <TextLink>
                  <BaSeSmall1
                    isBold
                    color={BaSeTheme.colors.defaultColors.white}
                    onClick={() => save()}
                  >
                    Reenviar o questionário novamente.
                  </BaSeSmall1>
                </TextLink>
              </ResultTextSubTitle>
            </ResultTextMessagetWrapper>
          </ResultBoxMessageWrapper>

          <ImageWrapper>
            <ImageResult
              imgIlustrationError={ilustration_error}
              imgIlustrationErrorResponsive={ilustration_error_resp}
              imgIlustrationSuccess={ilustration_success}
              imgIlustrationSuccessResponsive={ilustration_success_resp}
              isSuccess={false}
            />
          </ImageWrapper>
        </ResultWrapper>
      </Container>
    </React.Fragment>
  );
};

function getIcon(success) {
  return success ? 'clock-three' : 'exclamation-octagon';
}
